import { OfflineStore } from "./stores";

export async function fetchToStore<T>(
  url: string,
  options: RequestInit | undefined,
  store: OfflineStore
): Promise<T> {
  const res = await fetch(url, options);
  if (!res.ok) throw new Error("invalid response");
  const body = await res.json();
  await store.setItem(url, body);
  return body;
}

// NOTE: there may be value in introduction some caching strategies to prevent the
// users from not being able to see updates to bibles if they become available
// strategy: string | "stale-while-revalidate", "network-first", "cache-first", "network-only", "cache-only"

export async function storageFetch<T>(
  url: string,
  options: RequestInit | undefined,
  store: OfflineStore
): Promise<T> {
  const storedResult = await store.getItem(url);
  if (storedResult) return storedResult as T;
  const res = await fetch(url, options);
  return await res.json();
}
